module.exports = __webpack_public_path__ + "static/media/kpk.ce6f105d.png";